import { render, staticRenderFns } from "./EditarContrato.vue?vue&type=template&id=13ddb3c4"
import script from "./EditarContrato.vue?vue&type=script&lang=js"
export * from "./EditarContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports